import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';
import { mapSubscriptionBlockToViewDto } from '@subscriptions/application/mappers';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for getting a specific subscription block by ID.
 *
 * @param port - Subscription block API port
 * @returns Use case executor
 */
export const getSubscriptionBlockUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (blockUuid: string): Promise<SubscriptionBlockViewDto> => {
    try {
      const block = await port.getById(blockUuid);
      return mapSubscriptionBlockToViewDto(block);
    } catch (error) {
      subLog.error('getSubscriptionBlock', {
        ...extractErrorAttributes(error),
        'block.uuid': blockUuid,
      });
      throw error;
    }
  };

  return { execute };
};
